// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-11-19 01:18:36 +0100 (Wed, 19 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158364 $
//  Purpose   : admin parts
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {funcPart, loadLazy} from 'uix/parts'

// ---Exports
export {AdminHeader} from './header'
export {NodeOverview} from '../node_overview.js'

export const SessionsViewer = loadLazy(() => import(/* webpackChunkName: 'admin' */ './sessions'))
export const BibFormats = loadLazy(() => import(/* webpackChunkName: 'admin' */ './bibformats'))
export const InstanceCfgEditor = loadLazy(() =>
  import(/* webpackChunkName: 'admin' */ './instance_cfg')
)
export const SysOverview = loadLazy(() => import(/* webpackChunkName: 'admin' */ './sys_overview'))
export const SysError = loadLazy(() => import(/* webpackChunkName: 'admin' */ './sys_error'))
export const SysLogs = loadLazy(() => import(/* webpackChunkName: 'admin' */ './sys_logs'))
export const MirrorSync = loadLazy(() => import(/* webpackChunkName: 'admin' */ './mirror_sync'))
export const ArchiveInfo = loadLazy(() => import(/* webpackChunkName: 'admin' */ './archive_info'))

const PartDatabaseTables = loadLazy(() => import(/* webpackChunkName: 'admin' */ './dbtables'))

export const DatabaseTables = funcPart(
  {
    partStyle: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      fontSize: '0.9rem',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
  props => <PartDatabaseTables {...props} />
)
